import styled, { css } from 'styled-components';

import Course from 'Components/Search/Course/Course';
import { InputSearch, AutoComplete } from 'Components/Search/Course/Course.styled';
import { Input, Button } from 'Components/Search/Search.styled';

import { ReactComponent as WhiteLinesLong } from 'Public/graphics/clearing/lines--horizontal-long-grey.svg';
import { ReactComponent as WhiteLinesShortVertical } from 'Public/graphics/clearing/lines-vertical-short-white.svg';

interface decoration {
    $decoration: 'option1' | 'option2';
}

export const SearchWrapper = styled.div<{ $journeyCourseSearch: boolean }>`
    ${({ theme, $journeyCourseSearch }) => css`
        display: flex;
        align-items: center;
        margin-right: ${$journeyCourseSearch ? '1rem' : '0'};

        @media ${theme.breakpoints.smallLarge.media} {
            width: 100%;
            width: ${$journeyCourseSearch ? '90%' : '100%'};
        }
    `}
`;

export const Container = styled.div<{ $decoration; $journeyCourseSearch: boolean }>`
    ${({ theme, $decoration, $journeyCourseSearch }) => css`
        position: relative;
        gap: 1rem;
        padding: 1.5rem 2rem 2rem 1.5rem;
        color: ${theme.colors.primaryContrast.hex};
        background: ${theme.colors.campaigns.clearing.secondary.hex};
        flex-direction: column;

        ${!$journeyCourseSearch &&
        css`
            max-width: 100%;
            z-index: 1;
            margin: 0 auto;
            padding: 1rem;
            gap: 0;

            @media ${theme.breakpoints.medium.media} {
                margin: 0 auto 0 -2rem;
                max-width: 28rem;
            }

            @media ${theme.breakpoints.large.media} {
                margin: 0 auto 0 -4rem;
                padding: 1.5rem 2rem 2rem 1.5rem;
                gap: 1rem;
            }
        `}

        ${$decoration === 'option2' &&
        css`
            margin-right: 1rem;

            @media ${theme.breakpoints.medium.media} {
                margin-right: 1.25rem;
            }

            &::after {
                content: '';
                position: absolute;
                background-color: ${theme.colors.campaigns.clearing.primary.hex};
                width: 2rem;
                height: 7rem;
                top: -0.5rem;
                right: -1rem;
                z-index: -2;

                @media ${theme.breakpoints.large.media} {
                    height: 9rem;
                    width: 3rem;
                    right: -1.4rem;
                }
            }

            &::before {
                content: '';
                position: absolute;
                height: 5.5rem;
                width: 2rem;
                top: 4.5rem;
                right: -0.5rem;
                z-index: -1;
                background-color: ${theme.colors.secondary.tints[1].hex};

                @media ${theme.breakpoints.large.media} {
                    top: 6rem;
                    right: -0.75rem;
                    height: 10.5rem;
                    width: 3rem;
                }
            }
        `}

        ${$decoration === 'option1' &&
        css`
            @media ${theme.breakpoints.medium.media} {
                display: flex;
            }
        `}
    `}
`;

export const CopyContainer = styled.div<{ $journeyCourseSearch: boolean }>`
    ${({ theme, $journeyCourseSearch }) => css`
        h2 + p,
        h3 + p {
            margin-top: 0rem;
        }

        @media ${theme.breakpoints.large.media} {
            width: ${$journeyCourseSearch ? '100%' : '80%'};
        }
    `}
`;

export const DecorativeLinesLong = styled(WhiteLinesLong)<decoration>`
    ${({ $decoration }) => css`
        position: absolute;
        top: -0.75rem;
        right: 2.5rem;
        display: ${$decoration === 'option1' ? 'block' : 'none'};
    `}
`;

export const DecorativeLinesShortVertical = styled(WhiteLinesShortVertical)<decoration>`
    ${({ theme, $decoration }) => css`
        position: absolute;
        width: 1rem;
        display: ${$decoration === 'option2' ? 'block' : 'none'};
        right: -0.45rem;
        top: 1.25rem;
        height: 2rem;

        @media ${theme.breakpoints.large.media} {
            width: unset;
            height: unset;
            top: 1.5rem;
            right: -0.75rem;
        }
    `}
`;

export const Heading = styled.h2<decoration>`
    ${({ theme, $decoration }) => css`
        color: inherit;
        margin: ${$decoration === 'option1' ? '0.5rem 0 0.75rem' : '0rem 0rem 0.75rem'};
        font-size: 2rem;
        line-height: 1.2;

        @media ${theme.breakpoints.large.media} {
            margin: ${$decoration === 'option1' ? '0.5rem 0 0.75rem' : '0rem 0rem 0.75rem'};
            font-size: 2.5rem;
        }
    `}
`;

export const StyledCourseSearch = styled(Course)`
    ${({ theme }) => css`
        width: 100%;

        ${Input} {
            border-radius: 0rem;
            border: none;
            padding: 0rem 0.75rem;

            ::placeholder {
                font-size: 1.125rem;
            }
        }

        ${Button} {
            background-color: ${theme.colors.campaigns.clearing.primary.hex};
            border-radius: 0rem;
            width: 2.5rem;
        }

        ${InputSearch} {
            border-radius: 0rem;
        }

        ${AutoComplete} {
            border-radius: 0rem;
            box-shadow: none;
            border: ${theme.commonStyles.brandPixel} solid
                ${theme.colors.campaigns.clearing.secondary.hex};
        }
    `}
`;
